import ReferralWheel from './ReferralWheel';
export default ReferralWheel;